import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditTabsComponent } from './edit-tabs.component';
import { FiEditorPageModule } from '../../components/fi-editor-page/fi-editor-page.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiTabsModule } from '../tabs/tabs.module';
import { ButtonBackModule } from '../button-back/button-back.module';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { MatButtonModule } from '@angular/material/button';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonBackModule,
        FiTabsModule,
        FiAppTextSharedModule,
        FiEditorPageModule,
        FiValidatingFormModule,
        MatButtonModule,
        FiPageHeaderModule,
        MatIconModule,
    ],
    declarations: [EditTabsComponent],
    exports: [EditTabsComponent],
})
export class EditTabsModule {}
